import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d21095b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "news-main" }
const _hoisted_2 = { class: "news-header" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "news-header-region" }
const _hoisted_5 = { class: "news-header-title" }
const _hoisted_6 = { class: "news-header-text" }
const _hoisted_7 = { class: "news-content" }
const _hoisted_8 = { class: "news-content-main" }
const _hoisted_9 = { class: "news-content-title" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "news-content-border" }, null, -1))
const _hoisted_11 = { class: "news-content-description" }
const _hoisted_12 = { class: "news-list" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "news-item-img-box" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "news-item-medium" }
const _hoisted_17 = { class: "news-medium-title" }
const _hoisted_18 = { class: "news-medium-text" }
const _hoisted_19 = { class: "news-item-right" }
const _hoisted_20 = { class: "time-square" }
const _hoisted_21 = { class: "news-square-day" }
const _hoisted_22 = { class: "news-square-month" }
const _hoisted_23 = { class: "news-pages" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "news-header-img",
        src: require('@/assets/img/news/news-sub-bg.png')
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.newsText.subField1), 1),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.newsText.subField2), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createTextVNode(_toDisplayString(_ctx.newsText.subField3) + " ", 1),
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.newsText.subField4), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newsText.btns, (btn, index) => {
            return (_openBlock(), _createElementBlock("div", {
              onClick: ($event: any) => (_ctx.gotoDetail(btn)),
              key: index,
              class: "news-list-item cursor"
            }, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("img", {
                  class: "news-item-img",
                  src: btn.img
                }, null, 8, _hoisted_15)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, _toDisplayString(btn.title), 1),
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.formatText(btn.description)), 1)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, _toDisplayString(btn.day), 1),
                  _createElementVNode("div", _hoisted_22, _toDisplayString(btn.month) + "月", 1)
                ])
              ])
            ], 8, _hoisted_13))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_el_pagination, {
            onCurrentChange: _ctx.handleNewsPage,
            "page-size": 10,
            "pager-count": 5,
            layout: "prev, pager, next",
            total: _ctx.total
          }, null, 8, ["onCurrentChange", "total"])
        ])
      ])
    ])
  ]))
}